import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  watcherLinks: [],
  // Set on first successful fetch — watcher links are no longer preloaded at app startup (see
  // App.js); pages fetch on demand via useEnsureWatcherLinks, once per session.
  watcherLinksLoaded: false,
  error: null,
  isLoading: false
};

const watcherLinksSlice = createSlice({
  name: 'watcherLinks',
  initialState,
  reducers: {
    // General loading state for any request
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // General failure state for any request
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    setAllWatcherLinksSuccess: (state, action) => {
      state.watcherLinks = action.payload;
      state.watcherLinksLoaded = true;
      state.isLoading = false;
    },

    setUserWatcherLinkSuccess: (state, action) => {
      const index = state.watcherLinks.findIndex(
        item => item.userId === action.payload.userId
      );

      if (index !== -1) {
        state.watcherLinks[index] = action.payload;
      } else {
        state.watcherLinks.push(action.payload);
      }

      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  setAllWatcherLinksSuccess,
  setUserWatcherLinkSuccess
} = watcherLinksSlice.actions;

export default watcherLinksSlice.reducer;
